import * as React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
} from '@material-ui/core'
import { CellInfo, Column, RowInfo } from 'react-table'
import { t, jt } from 'ttag'
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/trash.svg'
import { getFullName } from '../../../../common/helpers/translations'
import { Button } from '../../../../components/Button/Button'
import { ButtonGroup } from '../../../../components/ButtonGroup/ButtonGroup'
import { Card } from '../../../../components/Card/Card'
import NotificationsWrapper from '../../../../components/Notification/NotificationsWrapper'
import { Table } from '../../../../components/Table/Table'
import {
  CompanyCountriesDto,
  CompanyId,
  DeleteUser$Request,
  DivisionDto,
  DivisionId,
  GetSpecificCompanyUsers$Request,
  SetUserCountry$Request,
  SetUserDivision$Request,
  ToggleUserStatus$Request,
  UserCompanyDto,
  UserId,
  UserDto,
} from '../../../../services/api.types'
import './UserManagement.scss'
import YumCountrySelect from '../../../../components/YumCountrySelect/YumCountrySelect'
import YumSmallSelect from '../../../../components/YumSmallSelect/YumSmallSelect'
import { red } from '../../../../styles/material-ui-theme-v2'
import YumSwitch from '../../../../components/YumSwitch/YumSwitch'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { getPeriodString, getShortDateWithTimeString } from '../../../../common/helpers/date'
import { getContractPeriod } from '../../../../common/helpers/challenges'
import { isSelectFieldErrorVisible } from '../../../../common/helpers/formHelpers'
import YumTeamSelect from '../../../../components/YumTeamSelect/YumTeamSelect'
import YumButton from '../../../../components/YumButton/YumButton'

export interface IUserManagementDispatchProps {
  getCompanyUsers(payload: GetSpecificCompanyUsers$Request): void
  getUserCompanyCountries(): void
  getCompanyDivisions(): void
  toggleUserStatus(payload: ToggleUserStatus$Request): void
  setUserCountry(payload: SetUserCountry$Request): void
  setUserDivision(payload: SetUserDivision$Request): void
  deleteUser(payload: DeleteUser$Request): void
  setCompanyUsersLoading(): void
}

export interface IUserManagementProps extends IUserManagementDispatchProps {
  companyUsers: UserDto[]
  usersLoading: boolean
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  managedCompanies: UserCompanyDto[]
}

interface IUserManagementState {
  openDeleteModalId: string | null
  userCompany: UserCompanyDto | undefined
}

export default class UserManagementNew extends React.PureComponent<IUserManagementProps, IUserManagementState> {
  state = {
    openDeleteModalId: null,
    userCompany: this.props.managedCompanies && this.props.managedCompanies[0],
  }

  parsedCompanyUsers = () =>
    this.props.companyUsers &&
    this.props.companyUsers.map((user: any) => {
      user.isCompleted = user.active

      return user
    })

  tableColumns = (companyId: CompanyId, companyUsersLength: number): Column<any>[] => {
    /*const useAutocompleteSelect =
      this.props.managedCompanies &&
      this.props.managedCompanies.some((uc) => uc.scope?.includes('useAutocompleteSelect'))*/
    const companyDivisions = this.props.divisions.filter((division) => division.companyId === companyId)
    const companyCountries = this.props.countries.find((country) => country.companyId === companyId)
    const columns: any = [
      {
        className: Table.rankBEM(companyUsersLength),
        headerClassName: Table.rankBEM(companyUsersLength),
        sortable: false,
        id: 'index',
        Cell: ({ viewIndex }: CellInfo) => <span>{`${viewIndex + 1}.`}</span>,
        style: { alignSelf: 'center' },
      },
      {
        Header: t`Name`,
        id: 'fullName',
        Cell: ({ original: { firstName, lastName, email } }: CellInfo) => (
          <>
            {/*<Initials isCompleted={isCompleted} fullName={getFullName(firstName, lastName, email)} />*/}
            <span>
              {firstName || lastName ? getFullName(firstName, lastName, email) : ''}
              <div className="text-gray">{email}</div>
            </span>
          </>
        ),
        accessor: (original: { firstName: string; lastName: string; email: string }) =>
          getFullName(original.firstName, original.lastName, original.email),
        style: { alignSelf: 'center' },
        //width: 200,
        minWidth: 200,
      },
      {
        Header: t`Registration date`,
        accessor: 'createdAt',
        Cell: ({ original }: RowInfo) => getShortDateWithTimeString(original.createdAt),
        style: { alignSelf: 'center', whiteSpace: 'nowrap' },
        minWidth: 200,
      },
    ]

    if (companyDivisions.length) {
      columns.push({
        Header: t`Team`,
        accessor: 'divisionName',
        Cell: ({ original: { userId, divisionId, maxTeamSize } }: RowInfo) => {
          return (
            <YumTeamSelect
              maxTeamSize={maxTeamSize}
              /*label={t`Team`}*/
              companyDivisions={companyDivisions}
              value={divisionId || ''}
              onChange={this.handleDivisionChange(userId)}
              /*useAutocompleteSelect={useAutocompleteSelect}*/
              style={{
                marginBottom: 0,
              }}
            />
            /*<YumSelect value={divisionId || ''} onChange={this.handleDivisionChange(userId)}>
              <option value="" />
              {companyDivisions.map((division, keyIndex) => (
                // @ts-ignore
                <option key={keyIndex} value={division.id}>
                  {division.name}
                </option>
              ))}
            </YumSelect>*/
          )
        },
        style: { alignSelf: 'center' },
      })
    }

    if (companyCountries && companyCountries.countries.length) {
      columns.push({
        Header: t`Country`,
        accessor: 'country',
        Cell: ({ original }: RowInfo) => {
          return (
            <YumCountrySelect
              /*label={t`Country`}*/
              countries={companyCountries.countries}
              value={original.country || ''}
              onChange={this.handleCountryChange(original.userId)}
              /*useAutocompleteSelect={useAutocompleteSelect}*/
              style={{
                marginBottom: 0,
              }}
            />
          )
        },
        style: { alignSelf: 'center' },
      })
    }
    columns.push({
      Header: t`Status`,
      accessor: 'active',
      Cell: ({ original: { active, userId } }: RowInfo) => (
        <YumSwitch checked={active} onChange={this.toggleUserStatus(companyId, userId)} color="primary" />
      ),
      //width: 120,
      style: { alignSelf: 'right' },
    })
    columns.push({
      Cell: ({ original: { userId, firstName, lastName, email } }: RowInfo) => (
        <>
          {/*<Button
            className="button--red ml-auto mr-0"
            link={true}
            onClick={this.openDeleteModal(userId)}
            iconLeft={CancelIcon}
          />*/}
          <IconButton style={{ color: red }} aria-label="delete" onClick={this.openDeleteModal(userId)}>
            <DeleteIcon
              style={{
                width: 24,
                height: 24,
              }}
            />
          </IconButton>

          <Dialog open={this.state.openDeleteModalId === userId}>
            <DialogTitle>{t`Delete user?`}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {jt`Are you sure you want to delete ${(<strong>{getFullName(firstName, lastName, email)}</strong>)}?`}
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <ButtonGroup>
                <Button text={t`Delete`} onClick={this.deleteUser(userId)} className="bg-red" />
                {/*<YumButton  onClick={this.deleteUser(userId)} className="bg-red">{t`Delete`}</YumButton>*/}
                <Button text={t`Cancel`} link={true} onClick={this.closeDeleteModal} />
              </ButtonGroup>
            </DialogActions>
          </Dialog>
        </>
      ),
      // @ts-ignore
      style: { width: '20px !important', alignSelf: 'right' },
      sortable: false,
      width: 80,
    })
    return columns
  }

  componentDidMount() {
    const { getUserCompanyCountries, getCompanyDivisions } = this.props
    getUserCompanyCountries()
    getCompanyDivisions()
    this.loadCompanyUsers()
  }

  loadCompanyUsers(): void {
    const { getCompanyUsers } = this.props
    const {
      userCompany: { companyId },
    } = this.state
    // For UserManagement component, we don't need division filtering
    // Just pass the companyId to get all users
    getCompanyUsers({ companyId })
  }

  openDeleteModal = (id: string) => () => this.setState({ openDeleteModalId: id })
  closeDeleteModal = () => this.setState({ openDeleteModalId: null })

  deleteUser = (userId: UserId) => () => {
    const {
      userCompany: { companyId },
    } = this.state
    this.props.deleteUser({ userId, companyId })
    this.setState({ openDeleteModalId: null })
  }

  toggleUserStatus = (companyId: CompanyId, userId: UserId) => () => {
    this.props.toggleUserStatus({ companyId, userId })
  }

  handleCountryChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const {
      userCompany: { companyId },
    } = this.state
    const { value } = event.target as { value: string }
    this.props.setUserCountry({ companyId, userId, country: value })
  }

  handleDivisionChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const {
      userCompany: { companyId },
    } = this.state
    const { value } = event.target as { value: DivisionId }
    this.props.setUserDivision({ companyId, userId, divisionId: value || null })
  }

  handleCompanyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { managedCompanies } = this.props
    const { value } = event.target as { value: CompanyId }
    this.setState({ userCompany: managedCompanies.find((company) => company.companyId === value) }, () => {
      this.props.setCompanyUsersLoading()
      this.loadCompanyUsers()
    })
  }

  render(): JSX.Element {
    const { usersLoading, companyUsers, managedCompanies } = this.props
    const {
      userCompany: { companyId, userLimit },
    } = this.state

    const contractPeriod = getContractPeriod(managedCompanies, companyId)

    return (
      <Card className="user-management">
        <NotificationsWrapper />

        <Grid container justifyContent="space-between" alignContent="center" alignItems="center">
          <Grid item xs={12} sm={8} style={{ paddingBottom: '10px' }}>
            <h1 style={{ marginBottom: 3 }}>
              {t`User management`}
              {!usersLoading && (
                <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                  {' '}
                  ({companyUsers.length}
                  {userLimit && `/${userLimit}`})
                </span>
              )}
            </h1>
            {/*<Button className="register__submit" url={ROUTES.ADMIN_USER_NEW.to} text={t`Add user`} />*/}
          </Grid>
          {managedCompanies.length > 1 ? (
            <Grid item style={{ overflow: 'hidden', paddingBottom: '1rem' /*, paddingLeft: '10px'*/ }}>
              <YumSmallSelect variant="outlined" value={companyId} onChange={this.handleCompanyChange}>
                {managedCompanies.map((userCompany: UserCompanyDto, keyIndex: number) => (
                  <option key={keyIndex} value={userCompany.companyId}>
                    {userCompany.companyName}
                  </option>
                ))}
              </YumSmallSelect>
            </Grid>
          ) : (
            ''
          )}
        </Grid>

        {!usersLoading && contractPeriod ? <div style={{ marginBottom: '20px' }}>{contractPeriod}</div> : ''}

        <Table
          className="users-table"
          data={this.parsedCompanyUsers()}
          isLoading={usersLoading}
          columns={this.tableColumns(companyId, companyUsers.length)}
        />
      </Card>
    )
  }
}
